import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CreateCampaignFormValues } from '~/features/campaigns/models/CreateCampaignFormValues';

interface CampaignFormSummaryProps {
  formValues: CreateCampaignFormValues;
}

const CampaignFormSummary: React.FC<CampaignFormSummaryProps> = ({ formValues }) => {

  const renderOrDash = (value: any) => value || <span className='text-color-gray'>—</span>;

  return (
    <div className="campaign-form-summary">
      <div className="margin-bottom-20">
        <p className='text-color-gray'>
          <FormattedMessage id='intl-msg:campaign:summaryForm:description'/>
        </p>
      </div>

      {/* Campaign Details Section */}
      <div className="card margin-bottom-20">
        <div className="card-header">
          <h5 className="margin-0">
            <FormattedMessage id='intl-msg:campaign:details'/>
          </h5>
        </div>
        <div className="card-body">
          <div className="display-flex flex-wrap">
            <div className="flex-basis-50pct padding-10">
              <div className="margin-bottom-10">
                <div className='text-color-gray'><FormattedMessage id='intl-msg:campaign:name'/></div>
                <div className='font-weight-bold'>{renderOrDash(formValues.campaignName)}</div>
              </div>
              <div className="margin-bottom-10">
                <div className='text-color-gray'><FormattedMessage id='intl-msg:deviceType'/></div>
                <div className='font-weight-bold'>{formValues.deviceType ? formValues.deviceType :
                    <span className='text-color-gray'>—</span>}</div>
              </div>
            </div>
            <div className="flex-basis-50pct padding-10">
              <div className="margin-bottom-10">
                <div className='text-color-gray'><FormattedMessage id='intl-msg:campaign:decisionBoardUrl'/></div>
                <div className="font-weight-bold">
                  {formValues.decisionBoardUrl ? (
                      <a href={formValues.decisionBoardUrl} target='_blank' rel='noopener noreferrer'>
                        {formValues.decisionBoardUrl}
                      </a>
                  ) : (
                      <span className='text-color-gray'>—</span>
                  )}
                </div>
              </div>
              <div className="margin-bottom-10">
                <div className='text-color-gray'><FormattedMessage id='intl-msg:campaign:additionalInformation'/></div>
                <div className='font-weight-bold'>{renderOrDash(formValues.description)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Target Deliverable Section */}
      <div className="card margin-bottom-20">
        <div className="card-header">
          <h5 className="margin-0">
            <FormattedMessage id="Target Deliverable" />
          </h5>
        </div>
        <div className="card-body">
          <table className="table margin-0">
            <thead>
              <tr>
                <th><FormattedMessage id='intl-msg:type'/></th>
                <th><FormattedMessage id='intl-msg:id'/></th>
                <th><FormattedMessage id='intl-msg:version'/></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{formValues.deliverableType ? formValues.deliverableType :
                    <span className='text-color-gray'>—</span>}</td>
                <td>{formValues.deliverableId ? formValues.deliverableId :
                    <span className='text-color-gray'>—</span>}</td>
                <td>{renderOrDash(formValues.deliverableVersion)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Target Vehicles Section */}
      <div className="card">
        <div className="card-header">
          <h5 className="margin-0">
            <FormattedMessage id='intl-msg:campaign:targetVehicles'/>
          </h5>
        </div>
        <div className='card-body margin-top-10'>
          {formValues.targetGroups ? (
            <div className="display-flex flex-wrap gap-10">
              <div className='badge badge-info padding-5'>{formValues.targetGroups}</div>
            </div>
          ) : (
              <p className='text-color-gray margin-0'><FormattedMessage id='NoGroupSelected'/></p>
          )}
        </div>
      </div>

      {/* Summary Note */}
      <div className="alert alert-info margin-top-20">
        <i className="rioglyph rioglyph-info-sign margin-right-5" />
        <FormattedMessage id='intl-msg:campaign:summaryForm:note'/>
      </div>
    </div>
  );
};

export default CampaignFormSummary;
